import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetIspsQuery, useLazyGetIspsQuery } from '../../redux/apis/domainsManagement/isp/dMIspApiSlice'
import { toast } from 'react-toastify'
import ReusableTable from '../../components/other/ReuseableTable'
import Loader from '../pages/loader'
import EditCreateIsp from '../../components/IPISP/EditCreateIsp'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import CountriesDropdown from '../../components/CountriesDropdown'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const Isp = React.memo(() => {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const context = useContext(AppSettings)

  const { data, isLoading, error, isFetching } = useGetIspsQuery({
    expand: ['last_updated_by', 'country'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'ISP NAME',
      dataIndex: 'isp_name',
      key: 'isp_name',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'COUNTRY',
      dataIndex: 'country',
      key: 'country.country_name',
      filter: true,
      filterComponent: CountriesDropdown,
      render: text => <div>{text?.country_name}</div>
    },
    {
      title: 'ABUSE EMAIL',
      dataIndex: 'abuse_email',
      key: 'abuse_email',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'ABUSE FORM',
      dataIndex: 'abuse_form',
      key: 'abuse_form',
      filter: true,
      filterType: 'text'
    },
    {
      title: 'UPDATED AT',
      dataIndex: 'updated_at',
      key: 'updated_at',

    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: text => (
        <div>
          {text?.first_name} {text?.last_name}
        </div>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (_, record) => (
        <div className='flex gap-2'>
          {can('change_isp') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {can('add_isp') && create && (
        <EditCreateIsp
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      )}
      {can('change_isp') && edit && (
        <EditCreateIsp
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      )}

      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetIspsQuery}
            fileName='isp'
          />
          {can('add_isp') && (
            <button
              className='btn btn-outline-theme ml-auto mb-4'
              onClick={() => setCreate(true)}
            >
              Create New ISP
            </button>
          )}
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default Isp
